const TOKENS = [
  { name: '默认令牌', key: 'sk-byt-••••••••abc', status: '活跃', created: '2025-05-20', lastUsed: '2025-05-28' },
];

const Tokens = () => (
  <>
    <p className="console-panel-desc">管理 API 访问令牌，创建、禁用或删除令牌。</p>
    <div style={{ marginBottom: '1rem' }}>
      <button type="button" className="console-btn">
        + 创建令牌
      </button>
    </div>
    <div className="console-card">
      <div className="console-card-body console-table-wrap">
        <table className="console-table">
          <thead>
            <tr>
              <th>名称</th>
              <th>密钥</th>
              <th>状态</th>
              <th>创建时间</th>
              <th>最近使用</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {TOKENS.map((token) => (
              <tr key={token.name}>
                <td>{token.name}</td>
                <td>
                  <code style={{ fontSize: '0.8125rem' }}>{token.key}</code>
                </td>
                <td>
                  <span className="console-tag success">{token.status}</span>
                </td>
                <td>{token.created}</td>
                <td>{token.lastUsed}</td>
                <td>
                  <button type="button" className="console-card-action">
                    管理
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>
);

export default Tokens;
